import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '@/features/auth/store';
import { syncNativePush } from '@/lib/native-push';
import { SplashScreen } from './SplashScreen';

export function ProtectedRoute() {
  const status = useSession((state) => state.status);
  const bootstrap = useSession((state) => state.bootstrap);
  const location = useLocation();

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  useEffect(() => {
    if (status === 'authenticated') void syncNativePush();
  }, [status]);

  if (status === 'idle' || status === 'loading') {
    return <SplashScreen />;
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
